<script setup lang="ts">
import { computed } from 'vue'
import { useBrandTheme } from '~/domain/shared/branding/composables/useBrandTheme'
import BagyIcon from '~/domain/shared/navigation/components/svgs/BagyIcon.vue'
import CplugIcon from '~/domain/shared/navigation/components/svgs/CplugIcon.vue'
import TrayIcon from '~/domain/shared/navigation/components/svgs/TrayIcon.vue'

interface Props {
  class?: string
  size?: string
}

const props = withDefaults(defineProps<Props>(), {
  class: undefined,
  size: '120px'
})

const { isBagy, isTray } = useBrandTheme()

const logoComponent = computed(() => {
  if (isBagy.value) {
    return BagyIcon
  }
  if (isTray.value) {
    return TrayIcon
  }
  return CplugIcon
})

const logoStyle = computed(() => ({
  width: props.size,
  height: '40px'
}))
</script>

<template>
  <div :class="['brand-logo-wrapper', props.class]" :style="logoStyle">
    <component :is="logoComponent" />
  </div>
</template>

<style scoped>
.brand-logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
